import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { ROUTE_IDS } from "../routeIds";
import { useDashboardNavigate } from "../hooks/useDashboardNavigate";
import { useProductContext } from "../providers/ProductContextProvider";
import { isFullLocale } from "../languageFeatures";
import { traceNonHebrewRouteBlock } from "../routeTelemetry";
import FeatureUnavailable from "../pages/FeatureUnavailable";

/**
 * Blocks non-Hebrew dashboard routes outside hotel search scope.
 * Redirects to HR_ROUTE_011 (hotel search) when possible.
 */
export function NonHebrewRouteBlock() {
  const location = useLocation();
  const { locale } = useProductContext();
  const dashNav = useDashboardNavigate();
  const hotelSearchPath = dashNav.pathFor(ROUTE_IDS.HOTEL_SEARCH);

  if (isFullLocale(locale)) {
    return <FeatureUnavailable reason="unexpected_block" />;
  }

  traceNonHebrewRouteBlock({
    locale,
    blockedPath: location.pathname,
    redirectTo: hotelSearchPath,
    targetRouteId: ROUTE_IDS.HOTEL_SEARCH,
  });

  if (hotelSearchPath) {
    return <Navigate to={hotelSearchPath} replace />;
  }

  return <FeatureUnavailable reason="missing_hotel_search_path" />;
}

export default NonHebrewRouteBlock;
